var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Main-Inner"},[_c('div',{staticClass:"Main-Content padding"},[_c('LoadingLayout')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }